import UserAvatar from '../../ui-kit/components/atoms/UserAvatar'
import NavItem from '../../ui-kit/components/atoms/items/NavItem'
import FloatContainer from '../../ui-kit/components/wrappers/FloatContainer'
import {USER_ICON} from '../../ui-kit/helpers/icons/user'
import {EXIT_ICON} from '../../ui-kit/helpers/icons/exit'
import {useMedia} from '../../ui-kit/hooks/useMedia'
import {mediaFromM} from '../../ui-kit/helpers/media-queries'
import routes from '../../config/routes'

const HeaderUserAvatar = ({}) => {
  const fromM = useMedia(mediaFromM)
  return (
    <div className="header-user-avatar">
      <FloatContainer>
        <div className="user">
          <UserAvatar />
          {fromM && <p>Evelyn Castrejón</p>}
        </div>
        <div className="float-container right-side">
          <ul className="list-container">
            <NavItem
              isInDropdown
              url={routes.config}
              icon={USER_ICON}
              text="Editar perfil"
            />
            <NavItem
              isInDropdown
              onClick={() => alert('Cerrar sesión')}
              className="logout"
              icon={EXIT_ICON}
              text="Cerrar sesión"
            />
          </ul>
        </div>
      </FloatContainer>
    </div>
  )
}

export default HeaderUserAvatar
